import { z } from "zod";

export function excludeBasicFields<T extends z.ZodObject<z.ZodRawShape>>(
  schema: T,
): z.ZodObject<Omit<T["shape"], "id" | "createdAt" | "updatedAt">> {
  const { id: _, createdAt: __, updatedAt: ___, ...rest } = schema.shape;
  return z.object(rest) as z.ZodObject<Omit<T["shape"], "id" | "createdAt" | "updatedAt">>;
}
